/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/frame2.glb
*/

import React, { useRef, useEffect, useState } from "react";
import { shaderMaterial, useGLTF, useTexture } from "@react-three/drei";
import { extend, useFrame } from "@react-three/fiber";
import * as THREE from "three";

const FrameMaterial = shaderMaterial(
  {
    uTexture: new THREE.Texture(),
    uFrameSize: new THREE.Vector2(1, 1),
    utextureSize: new THREE.Vector2(0.9, 0.9), // 🛑 Ensure it is initialized
  },
  `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  `
    uniform sampler2D uTexture;
    uniform vec2 utextureSize;
    varying vec2 vUv;

    void main() {
      vec2 centeredUV = vUv - 0.5;
      vec2 scaledUV = centeredUV * utextureSize;
      scaledUV += 0.5;
      scaledUV = clamp(scaledUV, 0.0, 1.0);
      gl_FragColor = texture2D(uTexture, scaledUV);
    }
  `
);

extend({ FrameMaterial });

useGLTF.preload("/3d/frame2.glb");
